<template>
  <div id="app" class="app-container">
    <div v-show="isShowNavBar" class="navBar">
      <span class="back" @click="back" v-show="isShow_hiddenBack" v-if="isShowBar">
        <van-icon name="arrow-left" />
      </span>
      <span class="navTitle">{{navTitle}}</span>
    </div>
    <navigation>
      <router-view></router-view>
    </navigation>
  </div>
</template>


<script>
import { getVersion } from "@/api/public";
import { isAndroid,isIOS } from "@/utils/validate"
export default {
  name: "app",
  data() {
    return {
      isShow_hiddenBack: true,
      isShowNavBar: true,
      navTitle: "",
      isApp:window.plus ? true : false,
      isBackTip:false,
      isShowBar:true
    };
  },
  created() {
    console.log('..',this.$route.path)
     if(this.$route.path=="/openOrder/orderCheckOut" || this.$route.path=="/openOrder/order"){
      this.isShowBar=false
    }
  },
  mounted() {
    var that = this
    document.addEventListener('plusready', function () {
      var activeVersion = String(plus.runtime.version)
      that.getActiveVersion(activeVersion)
    });
  },
  methods: {
    back() {
      if(this.isBackTip){
        this.$dialog.confirm({
          title: '确认返回',
          message: '您填写的内容还未保存，确认返回吗？',
        })
        .then(() => {
          // on confirm
          this.$router.go(-1);
        })
        .catch(() => {
          // on cancel
        });
      }else{
        this.$router.go(-1);
      }
    },
    // 更新版本
    getActiveVersion(activeVersion){
      getVersion({type:isAndroid()?1:2}).then(res=>{
        if(res.code == 200 ){
          if(res.data.version != activeVersion){
            plus.nativeUI.alert("应用有新版本，是否立即下载更新？", function(event) {
              if(event.index == 0) {
                plus.runtime.openURL( res.data.url);
              }
            },"版本更新","下载")
          }
        }
      })
    }
  },
  watch: {
    $route(to, from) {
      this.isShowNavBar = !to.meta.hidden;
      this.isShow_hiddenBack = !to.meta.hiddenBack;
      this.navTitle = to.meta.title;
      this.isBackTip = to.meta.backTip;
    }
  }
};
</script>

<style lang="less">
html,
body {
  // height: 100%;
  background-color: #f5f5f5;
}
#app {
  // height: 100%;
  // overflow: auto;
  position: relative;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 0.28rem;
  background-color: #f5f5f5;
  box-sizing: border-box;
}
.ellipsis-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fwb {
  font-weight: bold;
}
input {
  -webkit-tap-highlight-color: transparent;
  -webkit-appearance: none;
}
em {
  font-style: normal;
}

.navBar {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  font-family: PingFang SC;
  background-color: #fff;
  text-align: center;
  // background-color: #0db09b;
  box-shadow: 0rem 0.02rem 0.03rem 0rem #ddd;
  font-size: 0.36rem;
  // color: #fafafa;
  .back {
    width: 0.36rem;
    padding: 0 0.2rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .navTitle {
    width: 5.5rem;
    font-size: 0.36rem;
    color: #363638;
    font-weight: bold;
    position: absolute;
    left: 1rem;
    transition: 0.5s all;
  }
}

// 下拉刷新
.van-pull-refresh .van-list {
  padding-bottom: 0.3rem;
  overflow: initial;
}
.van-pull-refresh {
  overflow: initial !important;
}
.van-index-anchor{
  padding-right:0.42rem!important;
}
.van-cell {
  font-size: 0.32rem !important;
}
.van-index-bar__index {
  font-size: 0.32rem !important;
  line-height: 0.36rem !important;
}
.van-cell[disabled] {
  color: #999 !important;
}
</style>
